import { cva, type VariantProps } from "class-variance-authority";

/**
 * Growth Engine buttons (design-system.md §4 → Buttons). Labels are UPPERCASE,
 * 13px/700, tracking 0.04em. One PRIMARY (lime) per screen max.
 *   - primary        lime fill, dark text — the single main action.
 *   - accent-outline lime border + lime-tint bg + lime text — secondary emphasis.
 *   - outline        neutral border + value text — reject/pause/re-freeze.
 *   - ghost          bare, hover wash — low-emphasis controls.
 */
export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-ge-control font-sans text-[13px] font-bold uppercase tracking-ge-button transition-colors focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        primary: "bg-ge-accent text-ge-on-accent hover:bg-ge-accent-hover active:bg-ge-accent-pressed",
        "accent-outline":
          "border border-ge-border-accent bg-ge-accent-tint text-ge-accent hover:bg-ge-accent-tint/70",
        outline: "border border-ge-border-card text-ge-value hover:bg-white/[0.04]",
        ghost: "text-ge-value hover:bg-white/[0.04]",
      },
      size: {
        default: "px-4 py-[9px]",
        sm: "px-[13px] py-[7px] text-[12px]",
        lg: "h-11 px-6",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "default",
    },
  },
);

export type ButtonVariantProps = VariantProps<typeof buttonVariants>;
